/**
 * @author Andrea Moraglia
 */
export default interface AgencySearchBean {
    placeId: number;
    placeType: string;
    cityId: number;
    zoneId: number;
    localityId: number;
    provinceId: number;
    regionId: number;
    localityIdList: Array<number>;
    zoneIdList: Array<number>;
    cityDisplayName: string;
    cityURL: string;
    zoneURL: string;
    agencyName: string;
    franchiseId: number;
    categoryAssociationId: number;
    IDList: Array<number>;
    subscriptionTypes: Array<number>;

    polygonFromMap: string;
    latitude: number;
    longitude: number;

    [key: string]: any;
}

export const searchBeanMap: any = {
}

export function getDefaultAgencySearchBean(): AgencySearchBean {
    return {
        placeId: -1,
        placeType: "",
        cityId: -1,
        zoneId: -1,
        localityId: -1,
        provinceId: -1,
        regionId: -1,
        localityIdList: [],
        zoneIdList: [],
        cityDisplayName: "",
        cityURL: "",
        zoneURL: "",
        agencyName: "",
        franchiseId: -1,
        categoryAssociationId: -1,
        IDList: [],
        subscriptionTypes: [],
        polygonFromMap: "",
        latitude: -1,
        longitude: -1,
    }
}
